// extracted by mini-css-extract-plugin
module.exports = {"FindStyleNodatamain":"FindStyleNodata_FindStyleNodatamain__cPcPb","FindStyleNodatabox":"FindStyleNodata_FindStyleNodatabox__W4IK6"};